export default class TipoAtividadeWorkflow {

  constructor(
    IdTipoAtividade = null,
    IdWorkflow = null,
    Workflow = '',
  ) {
    this.IdTipoAtividade = IdTipoAtividade;
    this.IdWorkflow = IdWorkflow;
    this.Workflow = Workflow;
  }
  
}